// extracted by mini-css-extract-plugin
export default {"downloadBtn":"FileViewerDrawer_downloadBtn__NmTQk"};